import React from 'react'
import { TranslateFunction } from '@/utils/translate/translate-client'
import {
  GHeadingSM,
  GParagraphLG,
  GParagraphXL,
  GResponsiveText,
  GTitleMobile,
} from '@/views/PreSales/PreSalesGiveawayView/components/UI/Typography'

export const getSoloMioIntroText = (t: TranslateFunction) => (
  <div>
    <GResponsiveText
      color="giveaway-text-subtle-light"
      className="mb-10"
      MobileTextComponent={GParagraphLG}
      DesktopTextComponent={GParagraphXL}
    >
      {t(
        'soloMioIntroText1',
        'Starring Kevin James, Solo Mio isn’t just a romcom, it’s a reminder that life’s curveballs can lead to life’s greatest adventures.',
      )}
    </GResponsiveText>
    <GResponsiveText
      color="giveaway-text-subtle-light"
      MobileTextComponent={GParagraphLG}
      DesktopTextComponent={GParagraphXL}
    >
      {t(
        'soloMioIntroText2',
        'With Kevin James delivering laughs and heart, alongside stars like Jonathan Roumie and Alyson Hannigan, Solo Mio is sure to be a hilarious and heartfelt story you’ve never experienced before.',
      )}
    </GResponsiveText>
  </div>
)

export const getSoloMioPrizeText = (t: TranslateFunction) => (
  <div>
    <GResponsiveText
      color="giveaway-text-primary-dark"
      className="mb-3"
      MobileTextComponent={GTitleMobile}
      DesktopTextComponent={GHeadingSM}
    >
      {t('prizesList', 'Prizes List')}
    </GResponsiveText>
    <GParagraphLG color="giveaway-text-subtle-light" className="mb-10">
      {t(
        'soloMioGrandPrizeDesc',
        'One grand prize winner and their plus one will embark on the getaway of a lifetime that includes:',
      )}
    </GParagraphLG>
    <ul className="mb-10 flex list-disc flex-col gap-2 pl-6">
      <li>
        <GParagraphLG color="giveaway-text-subtle-light">
          {t('luxuryAccommodationsAndTravel', 'Luxury accommodations and travel.')}
        </GParagraphLG>
      </li>
      <li>
        <GParagraphLG color="giveaway-text-subtle-light">
          {t('exploreEternalCity', 'Explore the Eternal City’s ancient wonders and Florence’s Renaissance streets.')}
        </GParagraphLG>
      </li>
      <li>
        <GParagraphLG color="giveaway-text-subtle-light">
          {t('tourlikeAlocal', 'Tour like a local and visit the best these cultures have to offer.')}
        </GParagraphLG>
      </li>
      <li>
        <GParagraphLG color="giveaway-text-subtle-light">
          {t(
            'indulgeInAuthenticItalianCuisine',
            'Indulge in authentic Italian cuisine and wine tastings at world famous vineyards.',
          )}
        </GParagraphLG>
      </li>
      <li>
        <GParagraphLG color="giveaway-text-subtle-light">
          {t(
            'everyStopEchoesKevinJamesWildAdventure',
            'Every stop echoes Kevin James’ wild adventure through Italy’s stunning landscapes, delicious food, and vibrant culture.',
          )}
        </GParagraphLG>
      </li>
    </ul>
    <GParagraphLG color="giveaway-text-subtle-light" className="mb-2 !font-bold">
      {t('estimatedValue', 'Estimated Value: {{value}}', { value: '$30,000' })}
    </GParagraphLG>
  </div>
)

export const getSoloMioConfig = () => {
  return {
    grandPrizes: [
      {
        image:
          'https://images.angelstudios.com/image/upload/v1765309519/SOLO-MIO_Giveaway_Image-Ads_16x9_7_Day_Trip_xdrung.png',
        alt: '7-Day Trip for Two to Rome and Florence Italy',
        title: '7-Day Trip for Two to Rome and Florence Italy',
        value: '$20,000',
      },
      {
        image:
          'https://images.angelstudios.com/image/upload/v1763685664/solo%20mio/SOLO_MIO_Giveaway_Image-Ads_16x9_Cash_Prize.webp',
        alt: 'Cash Prize',
        title: 'Cash Prize',
        value: '$10,000',
      },
    ],
  }
}
